import MasterService from "./MasterService"

interface OtpRequest {
    // Define the structure of the 'params' object here
    email: string;
    password?: string;
    captcha?: string;
    resendOtp?: boolean;
}

export const UserService = {
    ...MasterService,
    
    loginCaptcha() {
        return this.post('/user/get_captcha')
    },

    googleWithLogin(params: OtpRequest) {
        return this.post('/user/login_with_google', params)
    },

    createOtp(params: OtpRequest) {
        return this.post('/user/create-otp', params)
    },

     VerifyOtp(params: OtpRequest) { 
        return this.post('/user/validate-otp', params)
    },
}